export const PREMIER_UPGRADE_TOOLTIP_SUFFIX = 'Available on Premier Plans.'
export const TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX = 'Team admin can update.'
